/**
 * «Добавить сцену» над списком сцен (спека §12): начало и конец в секундах, по умолчанию — первая дыра
 * не короче 0,7 с. Сервер проверяет пересечения (`OVERLAP`) и длину (`TOO_SHORT`).
 */
import { Plus } from "lucide-react";
import { useState } from "react";

import { Btn, inputClass } from "@/components/project/ui";
import { firstGap, parseSeconds, type VideoRefScene } from "@/lib/videoRef";

const sec = (ms: number) => String(Math.round(ms / 100) / 10).replace(".", ",");

export function AddSceneForm({
  scenes,
  totalMs,
  minMs,
  disabled,
  onAdd,
}: {
  scenes: VideoRefScene[];
  totalMs: number;
  minMs: number;
  disabled: boolean;
  onAdd: (body: { start_ms: number; end_ms: number }) => void;
}) {
  const [open, setOpen] = useState(false);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const toggle = () => {
    if (!open) {
      const gap = firstGap(scenes, totalMs, minMs);
      setStart(gap ? sec(gap.start_ms) : "");
      setEnd(gap ? sec(gap.end_ms) : "");
    }
    setOpen((v) => !v);
  };

  const s = parseSeconds(start);
  const e = parseSeconds(end);
  const ok = s !== null && e !== null && e - s >= minMs && e <= totalMs;

  return (
    <div className="flex flex-wrap items-center gap-2" data-annot="видео-референс: добавить сцену">
      <Btn onClick={toggle} disabled={disabled}>
        <Plus size={13} />
        добавить сцену
      </Btn>
      {open ? (
        <form
          className="flex flex-wrap items-center gap-1.5 text-[12.5px] text-fg-muted"
          onSubmit={(ev) => {
            ev.preventDefault();
            if (ok && !disabled) {
              onAdd({ start_ms: s, end_ms: e });
              setOpen(false);
            }
          }}
        >
          с
          <input
            value={start}
            onChange={(ev) => setStart(ev.target.value)}
            inputMode="decimal"
            aria-label="начало сцены, с"
            className={`${inputClass} tnum w-[64px] text-right`}
          />
          по
          <input
            value={end}
            onChange={(ev) => setEnd(ev.target.value)}
            inputMode="decimal"
            aria-label="конец сцены, с"
            className={`${inputClass} tnum w-[64px] text-right`}
          />
          с
          <Btn type="submit" tone="primary" disabled={!ok || disabled}>
            Добавить
          </Btn>
        </form>
      ) : null}
    </div>
  );
}
